export var LOCAL_STORAGE_KEYS;
(function (LOCAL_STORAGE_KEYS) {
    LOCAL_STORAGE_KEYS["THEME"] = "THEME";
})(LOCAL_STORAGE_KEYS || (LOCAL_STORAGE_KEYS = {}));
export const themes = ['light', 'dark'];
let pushstateCounter = null;
let replacestateCounter = 0;
const setTheme = () => {
    const savedTheme = localStorage.getItem(LOCAL_STORAGE_KEYS.THEME);
    if (savedTheme && themes.includes(savedTheme)) {
        document.body.classList.add('theme--' + savedTheme);
    }
};
const setupPopstateListener = () => {
    window.addEventListener('popstate', () => {
        pushstateCounter = null;
        replacestateCounter = 0;
    });
};
setTheme();
setupPopstateListener();
export const getBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let browser = 'unknown';
    if (userAgent.indexOf('firefox') > -1) {
        browser = 'firefox';
    }
    if ((window === null || window === void 0 ? void 0 : window.safari) !== undefined) {
        browser = 'safari';
    }
    if (userAgent.indexOf('chrome') > -1) {
        browser = 'chrome';
    }
    return browser;
};
export const sort = (sortBy, args, key = '') => {
    switch (sortBy) {
        case 'alphabetically':
            return args.sort((a, b) => (key ? a[key].localeCompare(b[key]) : a.localeCompare(b)));
    }
};
export const getSortedPropertyKeys = (propertyKeys, order) => {
    const ordered = [];
    const notOrdered = [];
    for (const entry of order) {
        if (propertyKeys.includes(entry)) {
            ordered.push(entry);
        }
    }
    for (const entry of propertyKeys) {
        if (!ordered.includes(entry)) {
            notOrdered.push(entry);
        }
    }
    return [...ordered, ...(notOrdered.length ? sort('alphabetically', notOrdered) : [])];
};
export const setHash = (href, replaceUrl = false) => {
    const hashed = '#' + href;
    if (pushstateCounter > 0 || replacestateCounter > 0 ||
        replaceUrl && (pushstateCounter > 0 || pushstateCounter === null)) {
        if (replaceUrl && pushstateCounter > 0) {
            pushstateCounter = null;
            replacestateCounter += 1;
        }
        href ?
            history.replaceState('', '', hashed) :
            history.replaceState('', document.title, window.location.pathname + window.location.search);
    }
    else {
        const ga = window.ga;
        if (typeof ga !== 'undefined') {
            ga('send', 'pageview', '/api/' + href);
        }
        href ?
            history.pushState('', '', hashed) :
            history.pushState('', document.title, window.location.pathname + window.location.search);
    }
    if (replaceUrl) {
        if (pushstateCounter !== null) {
            pushstateCounter += 1;
        }
    }
    else {
        pushstateCounter = 0;
        replacestateCounter = 0;
    }
};
export const getHash = () => {
    return decodeURI(location.hash.replace('#', ''));
};
export const setSearchParams = (parameters) => {
    const searchParams = new URLSearchParams(window.location.search);
    for (const param of parameters) {
        searchParams.set(param.key, param.value);
    }
    // pushstate to navigate without reloading
};
export const getTypeColors = (type) => {
    let color = 'grey-500';
    switch (type) {
        case 'array':
        case 'object':
        case 'integer':
        case 'float':
        case 'boolean':
        case 'string':
            color = type;
            break;
        case 'recursive':
            color = 'hint-600';
            break;
    }
    return 'var(--' + color + ')';
};
export const setKeysInObject = (keys, obj, i = 0) => {
    obj[keys[i]] && i <= keys.length - 2 ? setKeysInObject(keys, obj[keys[i]], i + 1) : obj[keys[i]] = {};
};
const recurseObject = (keys, obj, i = 0) => {
    return (obj[keys[i]] && i <= keys.length - 1 ? recurseObject(keys, obj[keys[i]], i + 1) : obj);
};
export const getKeyInObject = (keys, obj) => {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
        return;
    }
    if (!keys.length || !Object.keys(obj).length) {
        return obj;
    }
    return recurseObject(keys, obj);
};
export const createObjectMap = (key, parents, item, objectMap) => {
    if (item &&
        typeof item === 'object' &&
        !Array.isArray(item)) {
        parents = key ? [...parents, key] : parents;
        if (parents.length > 0) {
            setKeysInObject(parents, objectMap);
        }
        ;
        for (const childKey in item) {
            createObjectMap(childKey, parents, item[childKey], objectMap);
        }
    }
};
export const getCamelCaseBreakString = (string) => {
    return string.replace(/([a-z0-9])([A-Z])/g, '$1<wbr>$2');
};
export const getSlashBreakString = (string) => {
    return string.replace(/\//g, '/<wbr>');
};
